import { ringSolutionsURLs } from './constants';
import getEnvironment from '../enviroment';

function getBaseUri() {
  return ringSolutionsURLs[getEnvironment()];
}

export function professionalMonitoringSettings(locationId) {
  return `${getBaseUri()}/account/settings/monitoring?locationId=${locationId}`;
}

export function professionalMonitoring(locationId) {
  return `${getBaseUri()}/account/settings/monitoring/vsg-landing?locationId=${locationId}`;
}

export function emergencyContacts(locationId) {
  return `${getBaseUri()}/account/settings/monitoring/contacts?l=${locationId}&flow=vsgl`;
}

export function enableProfessionalMonitoring(locationId) {
  return `${getBaseUri()}/account/settings/monitoring/type?locationId=${locationId}&flow=vsgl`;
}

export function exitPracticeMode(locationId) {
  return `${getBaseUri()}/account/settings/monitoring/practice-activities?locationId=${locationId}&flow=vsgl`;
}

export function sharedUsersUri() {
  return `${getBaseUri()}/account/control-center/shared-users`;
}

export function getOnboarding30WelcomePageUrl(locationId) {
  if (locationId) return `${getBaseUri()}/account/settings/monitoring/signup?locationId=${locationId}&flow=vsgl`;
  return `${getBaseUri()}/account/settings/monitoring/signup?flow=vsgl`;
}

export function activityHistory(locationId, timestamp, isWebView) {
  return isWebView
    ? `https://ring.com/app/v3/locations/${locationId}/history`
    : `${getBaseUri()}/account/activity-history?l=${locationId}&vm=private&dr=${timestamp}-${timestamp}&etg=guard_reviewed`;
}

export function monitoredZonesWeb(locationId) {
  return `${getBaseUri()}/account/settings/monitoring/vsg/watch-zones/?locationId=${locationId}&flow=vsgl`;
}

export function monitoredZonesApp(locationId) {
  return `https://ring.com/app/v3/locations/${locationId}/settings/monitoring/virtual_security_guard/monitored_zones/`;
}
